import React from 'react';
// import { Link } from 'react-router-dom';
import '../styles/Footer.css';
import logo from '../assets/Branding/B&M_Logo/logo_in_white.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-logo-section">
          <img src={logo} alt="Bubble & Maple Logo" className="footer-logo" />
        </div>
        
        <div className="footer-newsletter">
          <h2 className="newsletter-title">Get 10% Off Your First Order</h2>
          <p className="newsletter-description">
            Join our community for first access to thoughtful content, promotions, product
            launches, and more.
          </p>
          <form className="newsletter-form">
            <input
              type="email"
              placeholder="Email"
              className="newsletter-input"
            />
            <button type="submit" className="newsletter-button">
              →
            </button>
          </form>
        </div>

        <div className="footer-quick-links">
          <h3 className="quick-links-title">Quick Links</h3>
          <div className="quick-links-list">
            <a href="/contact" className="footer-link">Book Now</a>
            <a href="/commercial" className="footer-link">Commercial</a>
            <a href="/residential" className="footer-link">Residential</a>
            <a href="/checklist" className="footer-link">Checklist</a>
            <a href="/careers" className="footer-link">Careers</a>
            <a href="/gallery" className="footer-link">Gallery</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 